import { facts } from "@/mocks/home";

function FastFacts() {
  return (
    <section id="archive" className="scroll-mt-24 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 font-label text-xs uppercase tracking-[0.24em] text-primary-600">
              Archive Snapshot
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              追踪档案速览
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            先给三组数字立个坐标系——截至整理时的公开情况一目了然，下面所有模块都围绕它们展开。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {facts.map((f) => (
            <div
              key={f.id}
              className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70"
            >
              <div className="flex items-baseline gap-1.5">
                <span className="font-heading text-4xl font-black tracking-tight text-foreground-950">
                  {f.value}
                </span>
                <span className="text-sm font-medium text-foreground-500">{f.unit}</span>
              </div>
              <p className="mt-3 text-sm font-semibold text-foreground-800">{f.label}</p>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{f.hint}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FastFacts;